import React, { useEffect } from "react";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import GitHubIcon from '@mui/icons-material/GitHub'; 
import DescriptionIcon from '@mui/icons-material/Description';
import JesseCV from "../assets/Jesse Washburn Resume 2026.pdf"; 
import "../styles/Home.css";

function Home() {
  useEffect(() => {
    document.title = "Jesse Washburn";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="home">
      <div className="about">
        <h2 className="animate-item animate-delay-1"> Jesse Washburn</h2>
        <div className="prompt">
          <p className="animate-item animate-delay-2">Software Engineer, Data Analyst, and Certified Scrum Master with 10 years of experience leading teams and delivering modern, reliable systems</p>
          <div className="icon-container">
            <a href="https://www.linkedin.com/in/jesse-washburn-24467428b/" target="_blank" rel="noopener noreferrer" className="animate-item animate-delay-3">
              <LinkedInIcon />
            </a>
            <a href="mailto:jeswashburn@gmail.com" className="animate-item animate-delay-4">
              <EmailIcon />
            </a>
            <a href="https://github.com/jessewashburn" target="_blank" rel="noopener noreferrer" className="animate-item animate-delay-5">
              <GitHubIcon />
            </a>  
            <a href={JesseCV} download="JesseWashburn_CV" className="animate-item animate-delay-6 download-cv">
              <DescriptionIcon />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
